// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-container{
  margin-top: 30px;
  margin-left: 99px;
  width: 80%;
  }
  .uom:focus{
    outline: none;
  
   }
   .remarks:focus{
    outline: none;
   }
   .uom{
    background-color: rgba(32, 35, 66, 1);
    width: 250px;
    height: 35px;
    border: 1px solid rgba(32, 35, 66, 1);
    color: white;
  
  }
  .remarks{
    background-color: rgba(32, 35, 66, 1);
    width: 250px;
    height: 35px;
    border: 1px solid rgba(32, 35, 66, 1);
    color: white;
  }
   .uom::placeholder{
    color: white;
   }
   .remarks::placeholder{
    color: white;
   }
  .popup{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: none;
  align-items: center;
  justify-content: center;
  }
  
  .popup.open {
  display: flex;
  }
  
  .popup-content {
  background: #464B7A;
  padding: 10px;
  
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
  .step-number{
      width: 30px;
    height: 30px;
    background-color: #3498db;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    z-index: 1;
    border:1px solid black;
  }
  .button-container {
      /* position: absolute; */
      /* margin-left: 600px; */
      width: 300px;
      height: 50px;
      margin-top: -60px;
      /* bottom: -70px; */
      right: 20px;
      border-radius: 10px;
      /* margin-bottom: 10px; */
    }
    .popup-content1 {
      background: #464B7A;
      padding: 10px;
      
      border-radius: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      }
    .row-opt{
      display: flex;
      margin-bottom: 20px;
      flex-direction: row;
    }
    .row-opt1{
      display: flex;
      margin-bottom: 10px;
      flex-direction: row;
    }
    .column-opt{
      display: flex;
      flex-direction: column;
    }
    
  
    .overlay-container-op {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 999; /* higher z-index to ensure it's on top */
    }
  
    .dot-loader-op {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      display: inline-block;
      margin: 5px;
      animation: pulse 1.5s infinite ease-in-out;
    }
  
    .red-loader-op { background-color: #5858FF; }
    .green-loader-op { background-color: #00ADEB; }
    .blue-loader-op { background-color: #00F2C2; }
  
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.2); }
    }
  
    .loading-text-op {
      text-align: center;
      color: #333; /* set your text color */
      font-size: 18px; /* set your font size */
      margin-top: 20px;
    }
    .opt-button{
     
     border-radius: 20px; /* Inherits the border-radius from parent */
      border: 2px solid white;
      margin: 10px;
      color: white;
      padding: 5px;
      background: transparent ;
      
  
    }
    .column-opt{
      margin-left: -16px;
      margin-top: 50px;
    }
    .opt-button1{
     
      border-radius: 20px; /* Inherits the border-radius from parent */
       border: 2px solid transparent;
      
       
       min-width: 100px;
       color: white;
       background: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) ;
       
   
     }
     .input-table:focus{
      outline: none;
     }
     
     .opt-button2{
     
      border-radius: 20px; /* Inherits the border-radius from parent */
       border: 2px solid transparent;
      
       
       width: 100px;
       color: white;
       background: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) ;
       
   
     }
    .border-element {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      
      border: 2px solid transparent;
      border-image: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) 1;
      z-index: -1;
    }
  .RSPBprogressBar {
      height: 5px !important;
      line-height: 1;
      border-radius: 10px;
      position: relative;
      background-color: #3498db !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 0;
  }
  
  /**Styling for Autocomplete screen**/
  
  .autoCmpt-div{
    background-color: #2A2D4E;
    border: 1px solid #747BA9;
    border-radius: 18px;
    margin-top: 70px;
    height: auto; 
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 150px;
    width:100%;
  }
  
  .autocomplete-header{
    color: #FFFFFF;
    font-family: 'Graphik';
    font-weight: 500;
    font-size: 14px;
    margin-top: 15px;
    text-align: center;
  }
  
  .autocomplete-row{
    padding:20px;
  }
  
  .autocomplete-button{
    justify-content: center;
  }
  
  .autcomplete-label{      
    color: #FFFFFF;
    font-family: 'Graphik';
    font-weight: 500;
    font-size: 13px;
  }
  
  .run-button{
    width:12% !important;
    border-radius: 20px; /* Inherits the border-radius from parent */
    border: 2px solid white;
    margin: 10px;
    color: white;
    background: #2A2D4E;
    height:40px;
    font-size: 13px;
  }
  
  .modal-label{
    color: #FFFFFF;
    font-family: 'Graphik';
    font-weight: 500;
    font-size: 14px;
  }
  
  .autosuggest-textarea{
    background: #21243e;
    border:none;
    width: 100%;
    color:white;
    padding-left: 20px;
  }
  
  .runmodalScrn-input{
    background: #21243e;
    border:none;
    color:white;
  }
  
  .modal-box{
    border-radius: 15px;
    border: 1px solid #9496a6;
    background: #3f425f;
    padding:17px;
  }
  
  .css-o4b71y-MuiAccordionSummary-content.Mui-expanded{
    margin:5px !important;
  }
  
  .css-o4b71y-MuiAccordionSummary-content{
    margin:5px 0px !important;
  }
  
  .css-1c35hjw-MuiPaper-root-MuiAccordion-root.Mui-expanded{
    margin:'0px';
  }
  
  .button-addRow{
    background: transparent;
    /* background: none;  */
    /* background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%); */
    /* border:2px solid ; */
    /* border-image: linear-gradient(to right,#72C9F8, #4545EB, #2A0589);
    border-image-slice: 1; 
    -webkit-border-radius: 25px; */
    border: 2px solid #0AAAE0;;
    border-radius: 25px;
    margin-top:10px;
    color:white;
    height:40px;
    width:12%;
    /* width:12%; */
    padding-bottom:5px;
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 13px;
  }
  
  .button-remove{
    background:none; 
    border:none;
  }
  
  .stepaccomplished .step-number{
    background-color: #50C878;
  }
  
  .stepaccomplished .progress-label{
    font-size: 12px;
    font-family: 'Graphik';
    color:'white';
    /* color:'#787878' !important; */
  }
  
  .progress-label{
    color:'#787878' !important;
  }
  
  .label-steps{
    font-size: 13px;
    font-family: 'Graphik';
    color:'white';
    }
    .label-steps-2::placeholder{
      color: #FFFFFF;
    }
  
  
  .icon-opt {
    position: relative;
  }
  
  .icon-opt input {
    padding-left: 30px;
  }
  
  .search-opt {
    border-style: solid;
    border-width: 1px;
    border-radius: 20px;
    border-color: #a31eba ;
    height: 30px;
    width: 270px;
    background-color: transparent;
    margin-left: 230%;
    margin-top: 17px;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    padding-left: 5px;
  }
  
  .search-opt::placeholder {
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    padding: 5px;
    /* font-family: 'italic'; */
  }
  
  .search-opt:focus {
    outline: none;
  }
  
  .icon-opt {
    position: absolute;
    left: 233%;
    top: 45%;
    transform: translateY(-50%);
  }
  
  .scrollBarClass::-webkit-scrollbar {
    width: 6px;
  }
  
  
  .scrollBarClass::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  
  /* Optional: Style the track (background) of the scrollbar */
  .scrollBarClass::-webkit-scrollbar-track {
    background-color: transparent;
  }
  
  .containerImg{
    position: relative;
    width: 100%; /* Set the width of the container */
  }
  
  .img-style {
    width: 1150px;
    height: 250px;
    margin-right: 15px;
    margin-left: 25px;
    margin-top: 1px;
    display: block;
  }
  
   /* Styling for the text overlay */
   .text-overlay {
    position: absolute;
    top: 52%; /* Position the text in the middle vertically */
    left: 30%; /* Position the text in the middle horizontally */
    transform: translate(-50%, -50%); /* Center the text exactly */
    background-color: rgba(0, 0, 0, 0.1); 
    /* Semi-transparent black background */
    /* background-color: #ADD8E6; */
    color: white; /* Text color */
    padding: 20px; /* Adjust the padding as needed */
    width: 55%; /* Set the width of the text overlay to 50% of the image */
    text-align: justify; /* Center the text horizontally */
  }
  
  select option {
    background-color: #3f425f; /* Set the background color */
    color: white;
  }`, "",{"version":3,"sources":["webpack://./src/Optimization/optimization.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV;EACA;IACE,aAAa;;GAEd;GACA;IACC,aAAa;GACd;GACA;IACC,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,YAAY;;EAEd;EACA;IACE,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,YAAY;EACd;GACC;IACC,YAAY;GACb;GACA;IACC,YAAY;GACb;EACD;EACA,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,gCAAgC;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;EAEA;EACA,aAAa;EACb;;EAEA;EACA,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;EACnB,uCAAuC;EACvC;EACA;MACI,WAAW;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,sBAAsB;EACxB;EACA;MACI,wBAAwB;MACxB,wBAAwB;MACxB,YAAY;MACZ,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,WAAW;MACX,mBAAmB;MACnB,yBAAyB;IAC3B;IACA;MACE,mBAAmB;MACnB,aAAa;;MAEb,mBAAmB;MACnB,uCAAuC;MACvC;IACF;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,sBAAsB;IACxB;;;IAGA;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,gCAAgC;MAChC,YAAY,EAAE,yCAAyC;IACzD;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qBAAqB;MACrB,WAAW;MACX,0CAA0C;IAC5C;;IAEA,iBAAiB,yBAAyB,EAAE;IAC5C,mBAAmB,yBAAyB,EAAE;IAC9C,kBAAkB,yBAAyB,EAAE;;IAE7C;MACE,WAAW,mBAAmB,EAAE;MAChC,MAAM,qBAAqB,EAAE;IAC/B;;IAEA;MACE,kBAAkB;MAClB,WAAW,EAAE,wBAAwB;MACrC,eAAe,EAAE,uBAAuB;MACxC,gBAAgB;IAClB;IACA;;KAEC,mBAAmB,EAAE,2CAA2C;MAC/D,uBAAuB;MACvB,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,wBAAwB;;;IAG1B;IACA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;IACA;;MAEE,mBAAmB,EAAE,2CAA2C;OAC/D,6BAA6B;;;OAG7B,gBAAgB;OAChB,YAAY;OACZ,8DAA8D;;;KAGhE;KACA;MACC,aAAa;KACd;;KAEA;;MAEC,mBAAmB,EAAE,2CAA2C;OAC/D,6BAA6B;;;OAG7B,YAAY;OACZ,YAAY;OACZ,8DAA8D;;;KAGhE;IACD;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,QAAQ;MACR,SAAS;;MAET,6BAA6B;MAC7B,iEAAiE;MACjE,WAAW;IACb;EACF;MACI,sBAAsB;MACtB,cAAc;MACd,mBAAmB;MACnB,kBAAkB;MAClB,oCAAoC;MACpC,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,UAAU;EACd;;EAEA,oCAAoC;;EAEpC;IACE,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB,EAAE,2CAA2C;IAChE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,2FAA2F;IAC3F,uBAAuB;IACvB;;kCAE8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,WAAW;IACX,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb;IACA;MACE,cAAc;IAChB;;;EAGF;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;;;EAGA;IACE,6BAA6B;EAC/B;;EAEA,4DAA4D;EAC5D;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,mCAAmC;EAClD;;EAEA;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;GAEC,iCAAiC;GACjC;IACC,kBAAkB;IAClB,QAAQ,EAAE,+CAA+C;IACzD,SAAS,EAAE,iDAAiD;IAC5D,gCAAgC,EAAE,4BAA4B;IAC9D,oCAAoC;IACpC,sCAAsC;IACtC,+BAA+B;IAC/B,YAAY,EAAE,eAAe;IAC7B,aAAa,EAAE,iCAAiC;IAChD,UAAU,EAAE,0DAA0D;IACtE,mBAAmB,EAAE,iCAAiC;EACxD;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,YAAY;EACd","sourcesContent":[".progress-container{\n  margin-top: 30px;\n  margin-left: 99px;\n  width: 80%;\n  }\n  .uom:focus{\n    outline: none;\n  \n   }\n   .remarks:focus{\n    outline: none;\n   }\n   .uom{\n    background-color: rgba(32, 35, 66, 1);\n    width: 250px;\n    height: 35px;\n    border: 1px solid rgba(32, 35, 66, 1);\n    color: white;\n  \n  }\n  .remarks{\n    background-color: rgba(32, 35, 66, 1);\n    width: 250px;\n    height: 35px;\n    border: 1px solid rgba(32, 35, 66, 1);\n    color: white;\n  }\n   .uom::placeholder{\n    color: white;\n   }\n   .remarks::placeholder{\n    color: white;\n   }\n  .popup{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: none;\n  align-items: center;\n  justify-content: center;\n  }\n  \n  .popup.open {\n  display: flex;\n  }\n  \n  .popup-content {\n  background: #464B7A;\n  padding: 10px;\n  \n  border-radius: 20px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  }\n  .step-number{\n      width: 30px;\n    height: 30px;\n    background-color: #3498db;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    z-index: 1;\n    border:1px solid black;\n  }\n  .button-container {\n      /* position: absolute; */\n      /* margin-left: 600px; */\n      width: 300px;\n      height: 50px;\n      margin-top: -60px;\n      /* bottom: -70px; */\n      right: 20px;\n      border-radius: 10px;\n      /* margin-bottom: 10px; */\n    }\n    .popup-content1 {\n      background: #464B7A;\n      padding: 10px;\n      \n      border-radius: 20px;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n      }\n    .row-opt{\n      display: flex;\n      margin-bottom: 20px;\n      flex-direction: row;\n    }\n    .row-opt1{\n      display: flex;\n      margin-bottom: 10px;\n      flex-direction: row;\n    }\n    .column-opt{\n      display: flex;\n      flex-direction: column;\n    }\n    \n  \n    .overlay-container-op {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 999; /* higher z-index to ensure it's on top */\n    }\n  \n    .dot-loader-op {\n      width: 15px;\n      height: 15px;\n      border-radius: 50%;\n      display: inline-block;\n      margin: 5px;\n      animation: pulse 1.5s infinite ease-in-out;\n    }\n  \n    .red-loader-op { background-color: #5858FF; }\n    .green-loader-op { background-color: #00ADEB; }\n    .blue-loader-op { background-color: #00F2C2; }\n  \n    @keyframes pulse {\n      0%, 100% { transform: scale(1); }\n      50% { transform: scale(1.2); }\n    }\n  \n    .loading-text-op {\n      text-align: center;\n      color: #333; /* set your text color */\n      font-size: 18px; /* set your font size */\n      margin-top: 20px;\n    }\n    .opt-button{\n     \n     border-radius: 20px; /* Inherits the border-radius from parent */\n      border: 2px solid white;\n      margin: 10px;\n      color: white;\n      padding: 5px;\n      background: transparent ;\n      \n  \n    }\n    .column-opt{\n      margin-left: -16px;\n      margin-top: 50px;\n    }\n    .opt-button1{\n     \n      border-radius: 20px; /* Inherits the border-radius from parent */\n       border: 2px solid transparent;\n      \n       \n       min-width: 100px;\n       color: white;\n       background: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) ;\n       \n   \n     }\n     .input-table:focus{\n      outline: none;\n     }\n     \n     .opt-button2{\n     \n      border-radius: 20px; /* Inherits the border-radius from parent */\n       border: 2px solid transparent;\n      \n       \n       width: 100px;\n       color: white;\n       background: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) ;\n       \n   \n     }\n    .border-element {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      \n      border: 2px solid transparent;\n      border-image: linear-gradient(45deg, #0ce39a, #69007f, #fc0987) 1;\n      z-index: -1;\n    }\n  .RSPBprogressBar {\n      height: 5px !important;\n      line-height: 1;\n      border-radius: 10px;\n      position: relative;\n      background-color: #3498db !important;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      z-index: 0;\n  }\n  \n  /**Styling for Autocomplete screen**/\n  \n  .autoCmpt-div{\n    background-color: #2A2D4E;\n    border: 1px solid #747BA9;\n    border-radius: 18px;\n    margin-top: 70px;\n    height: auto; \n    margin-left: 15px;\n    margin-right: 15px;\n    margin-bottom: 150px;\n    width:100%;\n  }\n  \n  .autocomplete-header{\n    color: #FFFFFF;\n    font-family: 'Graphik';\n    font-weight: 500;\n    font-size: 14px;\n    margin-top: 15px;\n    text-align: center;\n  }\n  \n  .autocomplete-row{\n    padding:20px;\n  }\n  \n  .autocomplete-button{\n    justify-content: center;\n  }\n  \n  .autcomplete-label{      \n    color: #FFFFFF;\n    font-family: 'Graphik';\n    font-weight: 500;\n    font-size: 13px;\n  }\n  \n  .run-button{\n    width:12% !important;\n    border-radius: 20px; /* Inherits the border-radius from parent */\n    border: 2px solid white;\n    margin: 10px;\n    color: white;\n    background: #2A2D4E;\n    height:40px;\n    font-size: 13px;\n  }\n  \n  .modal-label{\n    color: #FFFFFF;\n    font-family: 'Graphik';\n    font-weight: 500;\n    font-size: 14px;\n  }\n  \n  .autosuggest-textarea{\n    background: #21243e;\n    border:none;\n    width: 100%;\n    color:white;\n    padding-left: 20px;\n  }\n  \n  .runmodalScrn-input{\n    background: #21243e;\n    border:none;\n    color:white;\n  }\n  \n  .modal-box{\n    border-radius: 15px;\n    border: 1px solid #9496a6;\n    background: #3f425f;\n    padding:17px;\n  }\n  \n  .css-o4b71y-MuiAccordionSummary-content.Mui-expanded{\n    margin:5px !important;\n  }\n  \n  .css-o4b71y-MuiAccordionSummary-content{\n    margin:5px 0px !important;\n  }\n  \n  .css-1c35hjw-MuiPaper-root-MuiAccordion-root.Mui-expanded{\n    margin:'0px';\n  }\n  \n  .button-addRow{\n    background: transparent;\n    /* background: none;  */\n    /* background: linear-gradient(131.99deg, #0AAAE0 6.23%, rgba(10, 170, 224, 0.5) 85.46%); */\n    /* border:2px solid ; */\n    /* border-image: linear-gradient(to right,#72C9F8, #4545EB, #2A0589);\n    border-image-slice: 1; \n    -webkit-border-radius: 25px; */\n    border: 2px solid #0AAAE0;;\n    border-radius: 25px;\n    margin-top:10px;\n    color:white;\n    height:40px;\n    width:12%;\n    /* width:12%; */\n    padding-bottom:5px;\n    margin-bottom: 10px;\n    margin-left: 10px;\n    font-size: 13px;\n  }\n  \n  .button-remove{\n    background:none; \n    border:none;\n  }\n  \n  .stepaccomplished .step-number{\n    background-color: #50C878;\n  }\n  \n  .stepaccomplished .progress-label{\n    font-size: 12px;\n    font-family: 'Graphik';\n    color:'white';\n    /* color:'#787878' !important; */\n  }\n  \n  .progress-label{\n    color:'#787878' !important;\n  }\n  \n  .label-steps{\n    font-size: 13px;\n    font-family: 'Graphik';\n    color:'white';\n    }\n    .label-steps-2::placeholder{\n      color: #FFFFFF;\n    }\n  \n  \n  .icon-opt {\n    position: relative;\n  }\n  \n  .icon-opt input {\n    padding-left: 30px;\n  }\n  \n  .search-opt {\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 20px;\n    border-color: #a31eba ;\n    height: 30px;\n    width: 270px;\n    background-color: transparent;\n    margin-left: 230%;\n    margin-top: 17px;\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: 400;\n    padding-left: 5px;\n  }\n  \n  .search-opt::placeholder {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: 400;\n    padding: 5px;\n    /* font-family: 'italic'; */\n  }\n  \n  .search-opt:focus {\n    outline: none;\n  }\n  \n  .icon-opt {\n    position: absolute;\n    left: 233%;\n    top: 45%;\n    transform: translateY(-50%);\n  }\n  \n  .scrollBarClass::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  \n  .scrollBarClass::-webkit-scrollbar-thumb {\n    background-color: transparent;\n  }\n  \n  /* Optional: Style the track (background) of the scrollbar */\n  .scrollBarClass::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  \n  .containerImg{\n    position: relative;\n    width: 100%; /* Set the width of the container */\n  }\n  \n  .img-style {\n    width: 1150px;\n    height: 250px;\n    margin-right: 15px;\n    margin-left: 25px;\n    margin-top: 1px;\n    display: block;\n  }\n  \n   /* Styling for the text overlay */\n   .text-overlay {\n    position: absolute;\n    top: 52%; /* Position the text in the middle vertically */\n    left: 30%; /* Position the text in the middle horizontally */\n    transform: translate(-50%, -50%); /* Center the text exactly */\n    background-color: rgba(0, 0, 0, 0.1); \n    /* Semi-transparent black background */\n    /* background-color: #ADD8E6; */\n    color: white; /* Text color */\n    padding: 20px; /* Adjust the padding as needed */\n    width: 55%; /* Set the width of the text overlay to 50% of the image */\n    text-align: justify; /* Center the text horizontally */\n  }\n  \n  select option {\n    background-color: #3f425f; /* Set the background color */\n    color: white;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
